import React, { useEffect, useState } from 'react';
import { collection, query, where, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from '../firebaseConfig.tsx';
import { Link } from 'react-router-dom';
import PriceDisplay from './PriceDisplay';

export default function LatestProperties() {
    const [properties, setProperties] = useState([]);
  
    useEffect(() => {
      const fetchLatest = async () => {
        try {
            const q = query(
                collection(db, 'propiedades'),
                where('estado', '==', 'A'),
                orderBy('fecha_creacion', 'desc'),
                limit(6)
            );
            const querySnapshot = await getDocs(q);
            const props = querySnapshot.docs.map(doc => ({
                docId: doc.id,
                ...doc.data()
            }));
            setProperties(props);
        } catch (error) {
            console.error('Error cargando propiedades recientes:', error);
        }
      };

      fetchLatest();
    }, []);
  
    return (
      <div className="row justify-content-center">
        {properties.map((prop, idx) => (
          <div key={idx} className="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4">
            <div className="property-item border rounded shadow-sm overflow-hidden h-100">
  
              {/* Badge de tipo */}
              <div className="position-relative bg-light d-flex align-items-center justify-content-center" style={{ height: '200px' }}>
                {prop.fotos && prop.fotos.length > 0 ? (
                  <>
                    <img 
                      src={prop.fotos[0]} 
                      alt={prop.titulo || 'Propiedad'}
                      className="w-100 h-100"
                      style={{ objectFit: 'cover' }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'flex';
                      }}
                    />
                    <div className="d-none w-100 h-100 bg-secondary d-flex align-items-center justify-content-center">
                      <i className="fa-solid fa-image text-white fa-3x"></i>
                    </div>
                  </>
                ) : (
                  <div className="w-100 h-100 bg-secondary d-flex align-items-center justify-content-center">
                    <i className="fa-solid fa-image text-white fa-3x"></i>
                  </div>
                )}
                <span className={`badge position-absolute top-0 start-0 m-2 px-3 py-1 rounded-pill bg-primary text-white`}>
                  {prop.tipo_propiedad || 'Propiedad'}
                </span>
                <span className={`badge position-absolute top-0 end-0 m-2 px-3 py-1 rounded-pill bg-${prop.estado === 'A' ? 'success' : 'warning'} text-white`}>
                  {prop.estado === 'A' ? 'Activa' : prop.estado}
                </span>
              </div>
  
              <div className="property-content p-3">
                <h5 className="mb-1 text-truncate text-white" title={prop.titulo}>
                  {prop.titulo || prop.list_number || 'Propiedad'}
                </h5>

                {/* Ubicación */}
                <p className="small text-muted mb-2">
                  <i className="fa-solid fa-location-dot me-1"></i>
                  {prop.zona || prop.area || prop.ciudad || 'Riviera Nayarit'}
                </p>

                {/* Características */}
                <p className="small text-muted mb-2">
                  <i className="fa-solid fa-bed me-1"></i>
                  {prop.recamaras || 0} rec •
                  <i className="fa-solid fa-bath ms-2 me-1"></i>
                  {prop.banos_completos || prop.banos || 0} baños
                  {(prop.m2_total || prop.tamano_construccion) ? (
                    <>
                      • <i className="fa-solid fa-ruler-combined ms-2 me-1"></i>
                      {prop.m2_total || prop.tamano_construccion}m²
                    </>
                  ) : null}
                </p>
                
                {/* Precio — USD es fuente de verdad, MXN se calcula en PriceDisplay */}
                <div className="mb-3">
                  {(prop.precio_actual_usd > 0 || prop.precio_actual_mxn > 0 || prop.precio > 0) ? (
                    <PriceDisplay
                      priceMXN={prop.precio_actual_mxn || 0}
                      priceUSD={prop.precio_actual_usd || prop.precio || 0}
                      className="mb-0"
                      showExchangeRate={false}
                    />
                  ) : (
                    <div className="text-muted">Precio por consultar</div>
                  )}
                </div>
                
                <Link
                  to={`/single-property-1/${prop.docId}`}
                  className="btn btn-sm btn-primary w-100"
                  style={{ backgroundColor: '#02de7f', borderColor: '#02de7f', color: 'white' }}
                >
                  <i className="fa-solid fa-eye me-1"></i>
                  Ver Detalles
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
  